import { DefaultPageHeader } from 'layouts';
import { usePermissions } from 'permissions';
import { AdminConsoleButton } from 'features/admin-dashboard';
import { JoinedCommunitiesList } from './joined-communities-list';

type P = { getPathToCommunityDetail: (id: string) => string };

const JoinedCommunities = ({ getPathToCommunityDetail }: P) => {
  const { canViewAdminDashboardCommunities } = usePermissions();

  return (
    <>
      <DefaultPageHeader
        extra={canViewAdminDashboardCommunities({}) ? <AdminConsoleButton entityType="community" /> : null}
        title="Communities"
      />

      <JoinedCommunitiesList getPathToCommunityDetail={getPathToCommunityDetail} />
    </>
  );
};

export default JoinedCommunities;
